module.exports = __webpack_public_path__ + "img/pk.52975d36.svg";